/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hourglass_medium'
export default icon
